import React from "react";
import {AuctionsManager} from "@nextlot/core/webcast";


type CmpPropsType = {
    valueCents: number,
    className?: string
}

export function formatCurrency(valueCents) {
    return AuctionsManager.currentWebcastAuctionHandler.formatCurrencyAmount(valueCents);
}


export const CurrencyAmountDisplay = (props: CmpPropsType) => {
    return (
        <span className={props.className}>{formatCurrency(props.valueCents)}</span>
    )
};
